/**
 * HelpArticlePage — /help/:id: one article at reading width (the same ArticleView the panel uses).
 */

import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { ArticleView } from '../components/help/ArticleView';
import { useHelp } from '../components/help/HelpProvider';

export function HelpArticlePage() {
  const { id } = useParams<{ id: string }>();
  const { chatDisabled } = useHelp();

  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-4 px-[var(--page-padding-x)] pb-6" data-testid="help-article-page">
      <Link
        to="/help"
        data-testid="help-article-back"
        className="inline-flex min-h-[44px] items-center gap-1 self-start text-sm text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Help center
      </Link>

      {id && <ArticleView key={id} articleId={id} headingLevel="h1" />}

      <div className="flex flex-wrap items-center gap-2 border-t border-border pt-2">
        {!chatDisabled && (
          <Button asChild variant="ghost" className="text-primary">
            <Link to="/help/chat" data-testid="help-article-page-ask">
              Ask a question
            </Link>
          </Button>
        )}
        <Button asChild variant="ghost" className="text-primary">
          <Link to="/support" data-testid="help-article-page-contact">
            Contact support
          </Link>
        </Button>
      </div>
    </div>
  );
}
